export default __webpack_public_path__ + "static/media/eye.07602152.svg";